/**
 * TODO: consider moving this to polymer!
 */

import getIn from 'lodash.get';

export const getFSRefObjectId = (item) =>
  getIn(item, ['reference', 'object', '_id']);
export const getFSRefObject = (item) => getIn(item, ['reference', 'object']);
export const isDocFSObject = (item) =>
  getIn(item, ['reference', 'kind']) === 'EventDoc';
export const isStudioFSObject = (item) =>
  getIn(item, ['reference', 'kind']) === 'Broadcast';
export const isDirectory = (item) => item.isDirectory;

export const getFSObjectType = (item) => {
  if (isDirectory(item)) return 'folder';

  return 'doc';
};

export const getFSObjectName = (item) => {
  if (isDirectory(item)) return item.name;

  return (
    getIn(item, ['reference', 'object', 'title']) ||
    getIn(item, ['reference', 'object', 'name'])
  );
};

export const getFSObjectDesc = (item) => {
  if (isDirectory(item)) return item.description;
  if (isDocFSObject(item)) return null;

  return getIn(item, ['reference', 'object', 'description']);
};

export const getFileExtension = (fileName) => {
  const extPattern = /\.[0-9a-z]+$/i;

  const matches = extPattern.exec(fileName);

  if (!Array.isArray(matches)) return '';

  const [extMatch] = matches;

  return extMatch.toLowerCase();
};

export const getFileNameWithoutExtension = (fileName) => {
  const extPattern = /\.[0-9a-z]+$/i;
  return fileName.replace(extPattern, '');
};

/**
 * @param {Array} items
 * @param {Object} sorting
 * @returns Sorted Array of objects
 */
export const sortObjectListItems = (items, sorting) => {
  return items.sort((a, b) => {
    let aValue = a[sorting.sortBy];
    let bValue = b[sorting.sortBy];

    if (a.reference && b.reference && sorting.sortBy === 'displayType') {
      aValue = a.reference[sorting.sortBy];
      bValue = b.reference[sorting.sortBy];
    }

    if (aValue < bValue) {
      return sorting.sortDirection === 'asc' ? -1 : 1;
    }

    if (aValue > bValue) {
      return sorting.sortDirection === 'asc' ? 1 : -1;
    }

    return 0;
  });
};
